import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader.tsx';
import { Spinner } from 'dibs-elements/exports/Spinner.tsx';

import styles from './LoadingContent.module.css';

export const LoadingContent: FC = () => (
    <div>
        <BarHeader
            title={
                <FormattedMessage
                    id="nft.bidModal.loadingContent.header"
                    defaultMessage="Loading..."
                />
            }
        />
        <div className={styles.spinnerContainer}>
            <Spinner />
        </div>
    </div>
);
